import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

interface ButtonItemProps {
  title: string;
  value: string;
  action: () => void;
}
interface QuickFilterButtonGroupProps {
  buttons: Array<ButtonItemProps>;
  currentActiveFilter?: string;
  color?: string;
}
const QuickFilterButtonGroup = ({
  buttons,
  currentActiveFilter,
  color,
}: QuickFilterButtonGroupProps) => {
  const theme = useTheme();

  return (
    <ButtonGroup size="small" aria-label="small button group">
      {buttons.map((item) => {
        const isActive = currentActiveFilter === item.value;
        return (
          <Button
            sx={{
              height: '40px',
              // Inactive uses a surface token (white in light, dark in dark) so the
              // unselected buttons and their labels stay legible in both modes —
              // secondary.contrastText was a fixed white that vanished in dark mode.
              backgroundColor: isActive ? color : theme.semantic.surfaceRaised,
              color: isActive ? 'secondary.main' : 'text.secondary',
              border: `1px solid ${theme.palette.divider}`,
            }}
            variant={isActive ? 'outlined' : 'outlined'}
            key={item?.title}
            onClick={() => {
              item?.action();
            }}
          >
            {item.title}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
export { QuickFilterButtonGroup };
